import React, { createContext, useState, useContext, ReactNode } from 'react';

interface SignModalContextProps {
    isSignModalOpen: boolean;
    openSignModal: () => void;
    closeSignModal: () => void;
}

const SignModalContext = createContext<SignModalContextProps | undefined>(undefined);

export const SignModalProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [isSignModalOpen, setSignModalOpen] = useState(false);

    const openSignModal = () => setSignModalOpen(true);
    const closeSignModal = () => setSignModalOpen(false);

    return (
        <SignModalContext.Provider value={{ isSignModalOpen, openSignModal, closeSignModal }}>
            {children}
        </SignModalContext.Provider>
    );
};

export const useSignModal = (): SignModalContextProps => {
    const context = useContext(SignModalContext);
    if (!context) {
        throw new Error('useSignModal must be used within a SignModalProvider');
    }
    return context;
};
